"use strict";

exports.__esModule = true;
exports.DeviceTagListContext = void 0;
var _Utils = require("../../../Utils");
/**
 * Provides a list of device tags to consumers.
 * @component
 */
var DeviceTagListContext = exports.DeviceTagListContext = (0, _Utils.createEnhancedContext)({
  propName: "deviceTags"
});